import devConfig from "../Configurations/env";

export const Urls = devConfig.URLs;
